import React from "react";
import "../styles/HighPayingSkills.css";

const HighPayingSkills = () => {
  return (
    <div className="high-paying-skills-page">
      <h1>💰 Top 10 High-Paying Tech Skills in 2024</h1>
      <p>Boost your career with in-demand, high-paying skills.</p>

      <section className="skills-list">
        <h2>🔥 Must-Have Skills</h2>
        <ol>
          <li>1. **Machine Learning & AI** - Avg. Salary: ₹25 LPA</li>
          <li>2. **Cloud Computing (AWS, Azure, GCP)** - Avg. Salary: ₹22 LPA</li>
          <li>3. **Cybersecurity & Ethical Hacking** - Avg. Salary: ₹18 LPA</li>
          <li>4. **Full Stack Development (MERN/MEAN)** - Avg. Salary: ₹16 LPA</li>
          <li>5. **Blockchain Development** - Avg. Salary: ₹20 LPA</li>
          <li>6. **Data Science & Big Data Analytics** - Avg. Salary: ₹22 LPA</li>
          <li>7. **DevOps & CI/CD** - Avg. Salary: ₹17 LPA</li>
          <li>8. **AR/VR Development** - Avg. Salary: ₹19 LPA</li>
          <li>9. **Low-Code/No-Code Development** - Avg. Salary: ₹15 LPA</li>
          <li>10. **Quantum Computing** - Avg. Salary: ₹28 LPA</li>
        </ol>
      </section>

      <section className="courses">
        <h2>📚 Learn These Skills</h2>
        <p>Enroll in courses to master these high-demand skills.</p>
        <a href="/upskilling-courses" className="btn primary-btn">Explore Courses</a>
      </section>
    </div>
  );
};

export default HighPayingSkills;
